import { Pipe, PipeTransform } from '@angular/core';
import {TimezoneModel} from "../models/timezone.model";

@Pipe({
  name: 'timezoneFilterPipe'
})
export class TimezoneFilterPipe implements PipeTransform {

  transform(timezones: Array<{ offset: number, utc: string, timezone: string  }>, timezoneStr: string): any {
    timezoneStr = timezoneStr.toLowerCase();
    let filteredTimezones: Array<{ offset: number, utc: string, timezone: string  }> = [];
    if (timezoneStr.length == 0){
      return timezones;
    }
    for (let timezone of timezones){
      if(timezone.utc.toLowerCase().indexOf(timezoneStr) != -1 || timezone.timezone.toLowerCase().indexOf(timezoneStr) != -1 || timezone.offset.toString().indexOf(timezoneStr) != -1){
        filteredTimezones.push(timezone);
      }
    }
    return filteredTimezones;
  }

}
